import React, { useState, useEffect } from 'react';
import { PageHeader, Badge } from '../../components/UI';
import { adminApi } from '../../utils/api';

const SRC = { request_demo: '🎯 Demo', get_pricing: '💰 Pricing', talk_to_sales: '📞 Sales' };

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get('/api/admin/website-leads').then(r => { if (r.data.success) setLeads(r.data.leads); }).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="Website Leads" />
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>{['Name', 'Email', 'Phone', 'Source', 'Status', 'Date'].map(h => <th key={h} style={{ background: 'var(--bg)', padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: 0.5, borderBottom: '1px solid var(--border)' }}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {loading ? <tr><td colSpan="6" style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)' }}>Loading...</td></tr>
                : leads.length === 0 ? <tr><td colSpan="6" style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>No leads yet</td></tr>
                : leads.map(l => (
                  <tr key={l.id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '12px 14px', fontWeight: 600, fontSize: 13 }}>{l.name}</td>
                    <td style={{ padding: '12px 14px' }}><a href={`mailto:${l.email}`} style={{ color: 'var(--green)', fontSize: 13 }}>{l.email}</a></td>
                    <td style={{ padding: '12px 14px' }}><a href={`tel:${l.phone}`} style={{ color: 'var(--green)', fontSize: 13 }}>{l.phone}</a></td>
                    <td style={{ padding: '12px 14px' }}><Badge>{SRC[l.source] || l.source}</Badge></td>
                    <td style={{ padding: '12px 14px' }}><Badge>{l.status || 'new'}</Badge></td>
                    <td style={{ padding: '12px 14px', fontSize: 12, color: 'var(--text-muted)' }}>{new Date(l.created_at).toLocaleDateString('en-IN')}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}